var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_container"
  }, [_c('div', {
    staticClass: "powered_by"
  }, [_c('div', {
    staticClass: "dcomm_logo"
  }, [_vm.$root.theme === 'day' ? _c('img', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "src": require("@/assets/explorer_logo_dark.svg")
    }
  }) : _c('img', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "src": require("@/assets/explorer_logo.svg")
    }
  })]), _c('p', {
    staticClass: "footer_text dcomm_desc"
  }, [_vm._v(" DComm Explorer is an analytics tool that enables people to search the blockchain for transactions, addresses, and other authority activities. ")])]), _c('div', {
    staticClass: "footer_links"
  }, [_c('div', {
    staticClass: "footer_link"
  }, [_c('h4', [_vm._v("About Us")]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL("/comingsoon")
    }
  }, [_vm._v("DComm")])]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL("/comingsoon")
    }
  }, [_vm._v(" Career ")])]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL("/comingsoon")
    }
  }, [_vm._v(" Press ")])])]), _c('div', {
    staticClass: "footer_link"
  }, [_c('h4', [_vm._v("Products")]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL(_vm.walletURL),
      "target": "_blank"
    }
  }, [_vm._v("Wallet")])]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL(_vm.explorerURL),
      "target": "_blank"
    }
  }, [_vm._v("Explorer")])])]), _c('div', {
    staticClass: "footer_link"
  }, [_c('h4', [_vm._v("Primary Chains")]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL(_vm.actChainURL)
    }
  }, [_vm._v("ACT-Chain")])]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL(_vm.astChainURL)
    }
  }, [_vm._v("AST-Chain")])]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL(_vm.athChainURL)
    }
  }, [_vm._v("ATH-Chain")])])]), _c('div', {
    staticClass: "footer_link"
  }, [_c('h4', [_vm._v("Technology")]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL("/comingsoon")
    }
  }, [_vm._v("Dev Docs")])]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.generateURL("/comingsoon")
    }
  }, [_vm._v("Github")])]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL("/comingsoon")
    }
  }, [_vm._v("Tech Support")])]), _c('p', {
    staticClass: "footer_text"
  }, [_c('a', {
    attrs: {
      "href": _vm.generateURL("/comingsoon")
    }
  }, [_vm._v("White Papers")])])])])]), _c('div', {
    staticClass: "footer_copyright_container"
  }, [_c('div', {
    staticClass: "social_icons"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/dcomm_official"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "32px"
    },
    attrs: {
      "src": require("@/assets/instagram-button.svg")
    }
  })]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.linkedin.com/company/dcommventures/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "32px"
    },
    attrs: {
      "src": require("@/assets/linkedin-button.svg")
    }
  })]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/DCommBlockchain"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "32px"
    },
    attrs: {
      "src": require("@/assets/facebook-button.svg")
    }
  })]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.youtube.com/@dcommgroup7839/featured"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "32px"
    },
    attrs: {
      "src": require("@/assets/youtube-button.svg")
    }
  })]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://dcomm-official.medium.com/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "32px"
    },
    attrs: {
      "src": require("@/assets/medium-button.svg")
    }
  })]), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/DComm_Official"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "32px"
    },
    attrs: {
      "src": require("@/assets/twitter-button.svg")
    }
  })])]), _c('p', [_c('span', [_vm._v(" DComm @2022 ")]), _c('span', [_c('a', {
    attrs: {
      "href": _vm.generateURL("/comingsoon")
    }
  }, [_vm._v(" Terms of service ")])]), _c('span', [_c('a', {
    attrs: {
      "href": _vm.generateURL("/comingsoon")
    }
  }, [_vm._v(" Contact us ")])]), _c('span', [_c('a', {
    attrs: {
      "href": _vm.generateURL("/comingsoon")
    }
  }, [_vm._v(" Feedback ")])]), _c('span', [_c('a', {
    attrs: {
      "href": _vm.generateURL("/comingsoon")
    }
  }, [_vm._v(" Join us ")])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }